export const isFilterMatch = (giType: string, filterType: string) => {
  if (filterType === 'borehole') {
    return giType === 'BoringGEF' || giType === 'BoringIMBRO'
  } else {
    return giType === filterType
  }
}
